export default __webpack_public_path__ + "static/media/michael.1243bdb6.jfif";